import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import {
  BasicSelect
} from 'vue-search-select';
import PageTracker from '../../../common/PageTrackerHelper'

export default {
  name: 'DeliveredWhhandoverToInscan',
  components: {
    VueElementLoading,
    Treeselect,
    BasicSelect
  },
  mixins: [PageTracker],
  data: function() {
    return {
      shippingID: '',
      isLoading: false,
      ShipmentTypeList: [{
        text: "Delivery"
      }, {
        text: "DTO"
      }, {
        text: "RTO"
      }, {
        text: "RVP"
      }],
      ShipmentTypeObj: {
        text: ""
      },
      ShipmentType: '',
      userDataKey : '',
    }
  },
  created: function() {

  },
  mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
  },
  methods: {
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.Update();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    Update() {
      this.input = {
        "ShippingId": this.shippingID.trim(),
        "ShipmentType": this.ShipmentType,
        "LastModifiedBy": this.localusermailid
      }
      this.isLoading = true;
      axios({
          method: 'POST',
          url: apiUrl.api_url + 'websupport/update/shipment/delivered/to/inscan',
          data: this.input
        })
        .then(async result => {
          if (result.data.code == 200) {
            let TrackerInfo = {
              projectname:"Last Mile",
              type: "Web",
              userid: this.localuserid,
              username: this.localusermailid,
              meta: {
                  "event": "shipmentDelivered/Inscan",
                  "ShippingID": this.shippingID.trim().toString(),
                  "ShipmentType": this.ShipmentType              
                }
            }
            this.PageTracker(TrackerInfo);
            this.$alertify.success(result.data.message);
          } else {
            this.$alertify.error(result.data.message);
          }
          this.isLoading = false;
          this.reset();
        })
    },
    selectShipmentType(obj) {
      this.ShipmentTypeObj = obj,
        this.ShipmentType = obj.text;
    },
    reset() {
      this.$validator.reset();
      this.shippingID = '';
      this.isLoading = false;
      this.ShipmentTypeObj = {};
      this.ShipmentType = '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/DeliveredWhhandoverToInscan/DeliveredWhhandoverToInscan.component.js